import { FC, useState } from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  ListContextProvider,
  Pagination,
  TextField,
  useList,
} from 'react-admin';
import { useHttpClient } from 'shared/hooks/useHttpClient';
import { API_URL } from 'shared/constants/api-url';
import { AdminPaginatedB2BSessionsResponseDto } from 'shared/api';

interface Props {
  therapistId: string;
}

const TherapistB2BSessions: FC<Props> = ({ therapistId }) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data, isLoading, refetch } = useHttpClient<AdminPaginatedB2BSessionsResponseDto>(
    `${API_URL.sessionsB2B}?therapistId=${therapistId}&limit=${perPage}&page=${page}`,
  );
  const listContext = useList({
    data: data?.data ?? [],
    isLoading,
    page,
    perPage,
    sort: { field: 'availability.startDate', order: 'DESC' },
  });

  return (
    <>
      <ListContextProvider value={listContext}>
        <Datagrid bulkActionButtons={false}>
          <TextField source="status" sortable={false} label="Статус сессии" />
          <TextField
            source="cancelReason"
            sortable={false}
            label="Причина отмены сессии"
          />
          <DateField
            source="availability.startDate"
            showTime
            label="Дата начала сессии"
          />
          <TextField source="patients[0].phone" label="Телефон клиента" />
          <BooleanField
            source="isTherapistJoined"
            label="Посещено терапевтом"
          />
        </Datagrid>
        <Pagination
          isLoading={isLoading}
          page={page}
          perPage={perPage}
          total={data?.total}
          setPage={setPage}
          setPerPage={setPerPage}
        />
      </ListContextProvider>
    </>
  );
};

export default TherapistB2BSessions;
